import { Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { Home } from "lucide-react";
import { LANG_RE, pickLang } from "../lib/langs";

const PUBLIC = ["/magazine", "/condizioni-di-vendita", "/terms-and-conditions", "/it/", "/en/", "/fr/", "/de/", "/es/", "/ru/", "/pt/", "/ko/", "/amalfi-through-our-eyes", "/shop", "/collezione", "/guida", "/hotel/", "/destinazioni/", "/sito/", "/stazione/", "/q/free/", "/privacy-policy", "/cookie-policy", "/legale/", "/vintage", "/gestisci/", "/pagamento/"];
// Pages whose own header already links home: no extra button needed.
const OWN_HOME = ["/shop", "/collezione", "/sito/"];
const match = (path, p) => (p.endsWith("/") ? path.startsWith(p) : path === p || path.startsWith(`${p}/`));
const LABEL = { it: "Torna alla Home", en: "Back to Home", fr: "Retour à l'accueil", de: "Zur Startseite", es: "Volver al inicio", ru: "На главную", pt: "Voltar ao início", ko: "홈으로" };

const langOf = (pathname, search) => {
  const m = pathname.match(new RegExp(`^/(${LANG_RE})/`)) || search.match(new RegExp(`[?&]lang=(${LANG_RE})`));
  if (m) return m[1];
  return pickLang("en");
};

// In-flow link after the page content, so it never covers fields, prices or CTAs.
export default function HomeButton() {
  const { pathname, search } = useLocation();
  const [, setTick] = useState(0);
  useEffect(() => {
    const relang = () => setTick((n) => n + 1);
    window.addEventListener("av-lang-change", relang);
    return () => window.removeEventListener("av-lang-change", relang);
  }, []);
  if (pathname === "/" || !PUBLIC.some((p) => match(pathname, p)) || OWN_HOME.some((p) => match(pathname, p))) return null;
  const lang = langOf(pathname, search);
  return (
    <div className="flex justify-center bg-[#F7F5F0] py-5 pb-[calc(env(safe-area-inset-bottom)+20px)] border-t border-[#D8D2C8]">
      <Link to={`/?lang=${lang}`} data-testid="global-home-btn" className="inline-flex items-center gap-2 h-11 px-5 rounded-full border border-[#242321]/25 text-[#242321] text-[13px] font-semibold hover:bg-white transition-colors">
        <Home className="w-4 h-4" aria-hidden />{LABEL[lang] || LABEL.en}
      </Link>
    </div>
  );
}
